export default function() {
    const self = this

    self.getEvent()

    if (self.$route.params.messages) {
        self.openMessages = self.$route.params.messages
    }

    self.$root.$on('openMessage', (data) => {
        self.openMessages = data.jobId
    })
}
